// src/components/Checkout/PersonalInfo/MapEmbed/MapEmbed.jsx
import React, { useMemo } from "react";
import "./MapEmbed.css";

/**
 * coords: [lon, lat] — как в вашем объекте данных
 * title: подпись над картой (опционально)
 * height: высота iframe (по умолчанию 240)
 */
export default function MapEmbed({ coords, title = "На карте", height = 240 }) {
  const src = useMemo(() => {
    if (!Array.isArray(coords) || coords.length < 2) return null;
    const [lon, lat] = coords;
    if (
      typeof lon !== "number" ||
      typeof lat !== "number" ||
      Number.isNaN(lon) ||
      Number.isNaN(lat)
    ) {
      return null;
    }
    // Ваш айфрейм ждёт /lat/lon
    return `https://iframe-map.polza.tech/map/${lat}/${lon}`;
  }, [coords]);

  if (!src) return null;

  return (
    <div className="map-embed">
      {title ? <div className="map-embed__title">{title}</div> : null}
      <div className="map-embed__frame-wrap" style={{ height }}>
        <iframe
          className="map-embed__frame"
          src={src}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
          title="map"
        />
      </div>
    </div>
  );
}
